import { render, staticRenderFns } from "./ScopeAlert.vue?vue&type=template&id=3fe95889"
import script from "./ScopeAlert.vue?vue&type=script&lang=js"
export * from "./ScopeAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports